<template>
  <div class="login-signup-page">
    <v-toolbar>
      <v-toolbar-side-icon to="/">
        <v-icon class="back-button">keyboard_arrow_left</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>

    <!-- <v-btn color="info" to="/slides">Go to Slides</v-btn> -->
    <div class="full-screen full-screen-adjusted" id="fullscreen">
      <div class="sign-container">
        <div class="inputs">
          <div class="sign-title mb-5">
            <span>{{isSignUp? 'Sign Up' : 'Log In'}}</span>
          </div>

          <v-text-field dark label="Email" v-model="email" required></v-text-field>

          <div class="password">
            <v-text-field
              dark
              label="Password"
              :type="show? 'text' : 'password'"
              v-model="password"
              required
            ></v-text-field>

            <v-text-field
              v-if="isSignUp"
              dark
              label="Confirm password"
              type="password"
              v-model="confirm_password"
              required
            ></v-text-field>

            <v-btn v-if="!isSignUp" flat dark class="show pa-0 ml-0 mr-0" @click="showPassword">Show</v-btn>
          </div>

          <v-btn
            @click="submit"
            round
            large
            block
            color="primary"
            class="button-shadow-primary mt-5"
          >Ok</v-btn>
        </div>
      </div>

      <div class="forgot-password" v-if="!isSignUp && !keyboardOpen">
        <v-btn flat dark round @click="forgotPasswordClicked()">Forgot my password</v-btn>
      </div>
    </div>

    <v-dialog v-model="loading" width="320" persistent>
      <v-card class="loading-card">
        <div class="loading-body">
          <div class="loader">
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </div>
          <div class="loading-message">{{loading_message}}</div>
        </div>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="3000">{{message}}</v-snackbar>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import * as axios from "axios";

@Component({})
export default class LoginSignupPage extends Vue {
  show = false;

  loading = false;
  keyboardOpen = false;

  email = null;
  password = null;
  confirm_password = null;

  snackbar = false;
  message_ = null;
  loading_message_ = null;

  get isSignUp() {
    return this.$route.query.signup;
  }

  get message() {
    return this.message_;
  }

  set message(val) {
    this.message_ = val;
  }

  get loading_message() {
    return this.loading_message_;
  }

  set loading_message(val) {
    this.loading_message_ = val;
  }

  mounted() {
    const fullscreen = document.getElementById("fullscreen");
    const originalSize = fullscreen.offsetHeight;

    this.$nextTick(function() {
      window.addEventListener("resize", () => {
        const newSize = fullscreen.offsetHeight;
        this.keyboardOpen = originalSize > newSize;
      });
    });
  }

  showPassword() {
    this.show = true;

    setTimeout(() => {
      this.show = false;
    }, 3000);
  }

  openToast(message) {
    this.message = message;
    this.snackbar = true;
  }

  showLoading(message) {
    this.loading_message = message;
    this.loading = true;
  }

  stopLoading() {
    this.loading = false;
  }

  isOnline() {
    return navigator.onLine;
  }

  submit() {
    if (!this.isOnline) {
      this.openToast("Please switch on your internet before submitting");
      return;
    }

    let errorStatus, url_add;

    if (!this.isSignUp) {
      errorStatus =
        !this.email ||
        !this.password ||
        ((this.email != null && this.email.trim() === "") ||
          (this.password != null && this.password.trim() === ""));

      url_add = "login";
    } else {
      errorStatus =
        !this.email ||
        !this.password ||
        !this.confirm_password ||
        ((this.email != null && this.email.trim() === "") ||
          (this.password != null && this.password.trim() === "") ||
          (this.confirm_password != null &&
            this.confirm_password.trim() === ""));

      url_add = "users";
    }

    if (errorStatus) {
      this.openToast("Please fill in the inputs correctly");
      return;
    }

    const data = {
      email: this.email.slice(),
      password: this.password.slice()
    };

    this.resetInputs();

    this.showLoading("Confirming your details");

    axios
      .default({
        method: "post",
        url: `https://infinite-springs-88031.herokuapp.com/${url_add}`,
        data
      })
      .then(res => {
        this.$store.dispatch("setToken", res.data).then(() => {
          this.stopLoading();

          this.$store.dispatch("setItem", { credentials: data }).then(res => {
            const pathName = this.isSignUp ? "/slides" : "/menu";
            this.$router.push({ path: pathName });
          });
        });
      })
      .catch(e => {
        const message = e.response.data || "Please try again later";
        this.stopLoading();
        this.openToast(message);
      });
  }

  resetInputs() {
    this.email = null;
    this.confirm_password = null;
    this.password = null;
  }

  setItem(name, item) {
    return new Promise((resolve, reject) => {
      localStorage
        .get(name)
        .catch(function(err) {
          if (err.name === "not_found") {
            //// Where we save the doc
            return resolve({});
          } else {
            // hm, some other error
            return Promise.reject(err);
          }
        })
        .then(doc => {
          /// Where we save the document
          let Doc = doc;
          if (!Doc) {
            Doc = {};
            Doc._id = name;
          }
          Doc.item = item;
          return localStorage
            .put(Doc)
            .then(function(response) {
              // handle response
              return resolve(response);
            })
            .catch(function(err) {
              console.log(err);
              return reject(err);
            });
        })
        .catch(function(err) {
          // handle any errors
          console.log(err);
          reject(err);
        });
    });
  }

  // New forgot password feature
  async passwordResetAPIRequest(email) {
    try {
      const platform = "biostorify";
      await axios.default({
        method: "get",
        url: "https://prs-server.herokuapp.com/resetpassword",
        params: {
          email,
          platform
        }
      });
    } catch (e) {
      throw new Error(e.response.data.message);
    }
  }

  async startLoaderAndSendAPIRequest() {
    try {
      this.showLoading("Please wait..");

      const email = this.email;
      await this.passwordResetAPIRequest(email);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.stopLoading();
    }
  }

  async forgotPasswordClicked() {
    try {
      if (!this.email)
        return this.openToast("There's nothing filled in on the email field");

      await this.startLoaderAndSendAPIRequest();

      this.openToast(
        "We've sent you an email with a reset link. Please check it out"
      );
    } catch (e) {
      this.openToast("Sorry, please try again later");
    }
  }
}
</script>

<style lang="scss">
$primary: #95ff00;

.full-screen {
  height: 100%;
  width: 100%;
  position: absolute;

  .sign-title {
    font-size: 4em;
    text-align: center;
  }

  .sign-container {
    width: 100%;
    position: absolute;
    top: 3%;
    padding: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    input {
      color: white !important;
    }

    .inputs {
      height: 500px;
      max-width: 350px;
      width: 90%;

      .password {
        position: relative;
        .show {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }

    @media (min-width: 960px) {
      .inputs {
        height: 500px;
        padding: 0 40px;
        background-image: linear-gradient(
          to top,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.7),
          rgba(0, 0, 0, 0)
        );
      }
    }
  }

  .v-text-field > .v-input__control > .v-input__slot:before {
    border-width: 2px 0 0 !important;
    border-color: $primary;
  }

  .v-label {
    color: white;
  }
}

.forgot-password {
  width: 100%;
  position: absolute;
  margin-top: 20px;
  bottom: 0;
  text-align: center;
}

.full-screen-adjusted {
  height: calc(100% - 56px);
}
</style>


